/* Heavenly Crafted — real Shopify Add to Cart with success state.
   - posts to /cart/add.js, then refreshes real cart state from /cart.js
   - updates the real cart count
   - shows ADDED TO CART + View Cart / Checkout / Continue Shopping
   - full normal-form fallback if fetch/JS fails, so purchasing never breaks
   - never touches the inner text/price span, never touches the
     accelerated (dynamic) checkout button */
(function(){
  'use strict';
  var form = document.getElementById('gn-product-form');
  if(!form) return;
  var atc     = document.getElementById('gnp-atc');
  var atcText = document.getElementById('gnp-atc-text');
  var result  = document.getElementById('hc-atc-result');
  if(!atc) return;

  function setCount(n){
    document.querySelectorAll('#gn-cart-count,[data-cart-count]').forEach(function(el){ el.textContent = n; });
  }
  function refreshCount(){
    return fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root+'cart.js' : '/cart.js', {credentials:'same-origin'})
      .then(function(r){ return r.json(); })
      .then(function(c){ setCount(c.item_count); try{ document.dispatchEvent(new CustomEvent('gn:cart-updated',{detail:c})); }catch(e){} })
      .catch(function(){});
  }

  form.addEventListener('submit', function(e){
    if(atc.disabled) return;                 /* sold out — let it be */
    if(!window.fetch) return;                /* no fetch: normal form post */
    e.preventDefault();

    var original = atcText ? atcText.textContent : '';
    if(atcText) atcText.textContent = 'Adding…';   /* span preserved, only its text changes */
    atc.classList.add('is-loading');
    atc.setAttribute('aria-busy','true');

    fetch('/cart/add.js', {
      method:'POST',
      credentials:'same-origin',
      headers:{'Accept':'application/json'},
      body:new FormData(form)
    })
    .then(function(r){ if(!r.ok) throw new Error('add failed'); return r.json(); })
    .then(function(){
      if(atcText) atcText.textContent = original;
      atc.classList.remove('is-loading');
      atc.removeAttribute('aria-busy');
      if(result){
        result.classList.add('is-visible');
        result.setAttribute('role','status');
        if(result.scrollIntoView) result.scrollIntoView({behavior:'smooth',block:'nearest'});
      }
      return refreshCount();
    })
    .catch(function(){
      /* graceful fallback — submit the real form so the sale still happens */
      atc.classList.remove('is-loading');
      atc.removeAttribute('aria-busy');
      if(atcText) atcText.textContent = original;
      form.submit();
    });
  });
})();
